import { render, staticRenderFns } from "./ForgotPasswordSubmit.vue?vue&type=template&id=111b6a6f&scoped=true"
import script from "./ForgotPasswordSubmit.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordSubmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111b6a6f",
  null
  
)

export default component.exports